import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useHistory } from "react-router-dom";

const AdminProfileDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [name, setName] = useState("Admin");
  const [role, setRole] = useState("Admin");
  const open = Boolean(anchorEl);
  const history = useHistory();

  useEffect(() => {
    const storedName = localStorage.getItem("name");
    const storedRole = localStorage.getItem("role");

    if (storedName) setName(storedName);
    if (storedRole) setRole(storedRole);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    const BASE_AUTH_URL = process.env.REACT_APP_API_AUTH_BASE_URL;

    try {
      const response = await fetch(`${BASE_AUTH_URL}/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to logout");
      }

      alert(data.message);

      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("name");
      handleClose();
      history.push("/");
    } catch (error) {
      console.error("Logout error:", error);
      alert(error.message || "Something went wrong during logout.");
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={handleClick} sx={{ color: "white" }}>
        <Avatar sx={{ bgcolor: "grey" }}>
          <AccountCircle />
        </Avatar>
      </IconButton>
      <Box sx={{ ml: 1, textAlign: "right", color: "white" }}>
        <Typography variant="subtitle1">{name}</Typography>
        <Typography variant="caption">{role}</Typography>
      </Box>
      <IconButton onClick={handleClick} sx={{ color: "white" }}>
        {open ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleClose}>
          <AccountCircle sx={{ mr: 1 }} /> {name}
        </MenuItem>
        <MenuItem onClick={handleClose}>Support</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </Box>
  );
};

export default AdminProfileDropdown;
